import { Text, View } from "../../components/base";

export const AgentEvaluationEvaluateTab = () => (
  <View className="flex items-center justify-center rounded-md border border-dashed border-gray-200 dark:border-gray-700 py-24">
    <Text className="text-base font-medium text-gray-500 dark:text-gray-400">TODO</Text>
  </View>
);
